var watchlistList = {
	caption: "Volglijst lijst",
	name: "Naam",
	numberOfPositions: "Aantal Posities",
	actions: "Acties",
	createWatchlistAction: "Volglijst Toevoegen",
	editWatchlistAction: "Volglijst Bewerken",
	deleteWatchlistAction: "Volglijst Verwijderen",
	noWatchlist: {
		title: "Info",
		message: "Er is nog geen volglijst gemaakt. Klik op de knop Volglijst toevoegen en vul het formulier in om een volglijst te maken"
	},
	showActions: "Toon acties"
};
var nl = {
	watchlistList: watchlistList
};

export { nl as default, watchlistList };
